module.exports = __webpack_public_path__ + "static/media/phone_touch_with_person_icon.31763393.svg";